import { useAuth } from '../../contexts/AuthContext';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import '../../styles/admin.css';

export default function AdminPage() {
  const { user, loading } = useAuth();

  if (loading) return null;
  return user ? <AdminDashboard /> : <AdminLogin />;
}
